import { defineFcm } from '../shared/factory';

export const FCM_SPH_CONTACT_DECISION_MAKER_ENABLED = defineFcm('sph_contact_decision_maker_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Supporter → DM Outreach',
		description:
			'Gates the contact-decision-maker surface on Signed Petition Home: off, the checklist item does not render. It is the only switch for the surface — a single global row set to `true` enables it everywhere; use a country or locale row to narrow the rollout (most specific row wins). The petition must still have a contactable local or state decision maker.',
	});
